import { ImageWithText } from '@quicktools/shared-components/components/landingPages/ImageWithText';
import ImageWithTextScrollable from '@quicktools/shared-components/components/landingPages/ImageWithTextScrollable';
import { IMG_WITH_TEXT_SIZES } from '@quicktools/shared-components/components/landingPages/constants';
import { SingleToolSimilar } from '@quicktools/shared-components/components/common/SingleToolSimilar';
import { memo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {
  MARKETING_SLOGAN_TOOL,
  AD_COPY_GENERATOR_TOOL,
  SOCIAL_MEDIA_BIO_TOOL,
  FONT_GENERATOR_TOOL,
  ToolCategory,
} from '@quicktools/shared-components/data';

import analytics from '../../../services/analytics';

import useStyles from './styles';

const SIMILAR_TOOLS = [SOCIAL_MEDIA_BIO_TOOL, AD_COPY_GENERATOR_TOOL, MARKETING_SLOGAN_TOOL];

function StaticSection() {
  const { t } = useTranslation();
  const classes = useStyles();

  const scrollable = [0, 1, 2, 3, 4, 5].map((i) => ({
    title: t(`static.CaseConverter.scrollable.items.${i}.title`),
    description: (
      <Trans
        i18nKey={`static.CaseConverter.scrollable.items.${i}.description`}
        components={{ br: <br /> }}
      />
    ),
    alt: t(`static.CaseConverter.scrollable.items.${i}.alt`),
    src: t(`static.CaseConverter.scrollable.items.${i}.src`),
  }));

  return (
    <div className={classes.root}>
      <ImageWithText
        alt={t('static.CaseConverter.imageWithText.alt')}
        title={
          <Trans
            i18nKey="static.CaseConverter.imageWithText.title"
            components={{ strong: <strong /> }}
          />
        }
        description={
          <Trans
            i18nKey="static.CaseConverter.imageWithText.description"
            components={{ span: <span />, a: <a /> }}
          />
        }
        src="https://pastatic.picsart.com/cms-pastatic/671e507c-05ba-412d-aba6-b5d26f2cd4b7.png"
        srcSet="https://pastatic.picsart.com/cms-pastatic/6e54117a-8575-4703-9e58-5ab002b47211.png 327w,https://pastatic.picsart.com/cms-pastatic/671e507c-05ba-412d-aba6-b5d26f2cd4b7.png 648w"
        sizes={IMG_WITH_TEXT_SIZES}
      />
      <ImageWithTextScrollable
        title={<Trans i18nKey="static.CaseConverter.scrollable.title" components={{ b: <b /> }} />}
        items={scrollable}
      />
      <SingleToolSimilar
        current={FONT_GENERATOR_TOOL}
        analytics={analytics}
        similar={SIMILAR_TOOLS}
        paragraph={t('similarTxt')}
        category={ToolCategory.Text}
      />
    </div>
  );
}

export default memo(StaticSection);
